import { ref } from "@vue/reactivity";
import NavBar from "@/view/components/nav-bar/nav-bar.vue";
import SessionUtil from "@/utils/SessionUtil";
import RouterUtil from "@/utils/RouterUtil";
export default {
  name: "UserProfile",
  components: {
    NavBar
  },
  setup() {
    const title = ref("账号和个人信息");
    const userData = ref();
    return {
      title,
      userData
    };
  },
  mounted() {
    this.userData = SessionUtil.getUserData();
  },
  methods: {
    goCommute() {
      RouterUtil.go("/user/commute", false, this.$route.path);
    }
  }
};